import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import TechServicesSection from '../../Components/Automation/TechServicesSection'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import WhyPartnerWithUs from '../../Components/Automation/WhyPartnerWithUs'
import { ArrowRight } from 'lucide-react'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'


const featuresData = [
    {
        id: 1,
        title: "Future-Ready Enterprises",
        description: "Shift from manual, repetitive tasks to AI-driven autonomy. We help build resilient systems that adapt to market changes instantly.",
        image: "/assets/career/img10.png",
    },
    {
        id: 2,
        title: "Smarter Decision-Making",
        description: "Leverage advanced analytics and machine learning models to process vast amounts of data, turning noise into actionable business insights.",
        image: "/assets/home-/ai-2.png",
    },
    {
        id: 3,
        title: "Customer-First Engagement",
        description: "Personalize every touchpoint with AI-powered recommendations and chatbots that understand intent, ensuring a seamless customer journey.",
        image: "/assets/home-/ai-3.png",
    },
    {
        id: 4,
        title: "End-to-End Value",
        description: "From strategy to execution, we ensure that automation is not just a tool but a value driver that optimizes costs and maximizes efficiency.",
        image: "/assets/home-/ai-4.png",
    },
];


// --- DATA ---
const services = [
    {
        id: 1,
        title: "AI & Automation",
        category: "service",
        desc: "Helping businesses work smarter with AI and automation, making everyday tasks easier, reducing costs, and supporting steady, meaningful growth.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
    },
    {
        id: 2,
        title: "Cloud Engineering",
        category: "service",
        desc: "We build secure cloud systems that fit your business and grow with you smoothly.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
    },
    {
        id: 3,
        title: "Product Engineering",
        category: "service",
        desc: "We help turn ideas into real products designing, building, and scaling them so they can grow confidently and succeed in global markets.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
    },
    {
        id: 4,
        title: "Performance Engineering",
        category: "service",
        desc: "Improve systems for better speed, stability, efficiency, and reliability.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
    },
    {
        id: 5,
        title: "ServiceNow Consulting",
        category: "service",
        desc: "We help simplify your business processes with expert ServiceNow implementation and guidance.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
    },
    {
        id: 6,
        title: "Infor M3 Solutions",
        category: "service",
        desc: "Helping enterprises streamline operations with tailored Infor M3 ERP solutions and dedicated support.",
        defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
    },
    {
        id: 7,
        title: "MES Solutions",
        category: "service",
        desc: "We evaluate MES readiness, understand current maturity, and build practical roadmaps with clear business value.",
        defaultBg: "bg-gradient-to-tl from-[#01386A] to-[#141E30]",
    },
    // {
    //     id: 8,
    //     title: "Building Automation Solutions",
    //     category: "service",
    //     desc: "We build smart Building Management Systems that make everyday operations easier. From sensors and equipment to full control and monitoring, everything is connected in one simple system for smoother, more efficient building management.",
    //     defaultBg: "bg-gradient-to-l from-[#01386A] to-[#0E2A62]",
    // },
    {
        id: 9,
        title: "Industrial Automation Solutions",
        category: "service",
        desc: "We help industries run smarter with complete automation solutions, from field devices to PLC, DCS, SCADA, and data systems. Our focus is simple: make operations more reliable, efficient, and easy to manage every day.",
        defaultBg: "bg-gradient-to-br from-[#004e92] to-[#01386A]",
    },
];
function NewAI() {
    return (
        <div>
            <Helmet>
    <title>
        AI & Automation Services | Intelligent Business Automation | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode delivers AI and intelligent automation services that help enterprises streamline operations, improve customer experiences, automate workflows, optimize costs, and drive sustainable business growth."
    />

    <meta
        name="keywords"
        content="AI Automation Services, AI & Automation Solutions, Intelligent Automation Services, AI Automation Company, Enterprise AI Solutions, AI Workflow Automation, Business Process Automation, Intelligent Business Automation, AI Consulting Services, AI Powered Automation, Enterprise Automation Solutions, AI Enterprise AI & ServiceNow Consulting Company, Industrial Automation Solutions, Automation Consulting Services"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/ai-automation"
    />

    <meta
        property="og:title"
        content="AI & Automation Services | Intelligent Business Automation | Mobikode"
    />

    <meta
        property="og:description"
        content="Transform business operations with Mobikode's AI and intelligent automation solutions. Build smarter workflows, enhance customer engagement, improve decision-making, and create scalable digital operations."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/ai-automation"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/service-detail/bg3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="AI & Automation Services | Intelligent Business Automation | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's AI and automation solutions for intelligent workflows, customer engagement, enterprise operations, cloud, product engineering, ServiceNow, ERP, and industrial automation."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/service-detail/bg3.png"
    />
</Helmet>
            <AiHero title="AI & Automation" text="Technology. Transformation. Trust." imgData="/assets/service-detail/bg3.png" />
            <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    {/* Mobile par stack (flex-col) aur desktop par row (flex-row). Fixed height (507px) sirf desktop ke liye. */}
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">

                        {/* Image Box: Mobile pe relative/fixed height aur desktop pe absolute */}
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/career/img9.jpg"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        {/* Text Box: Mobile pe center align (mx-auto) aur upar overlap karne ke liye negative margin (-mt-[40px]) */}
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">

                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                Empowering Enterprises with Intelligent Automation
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we help forward-thinking businesses make the most of AI and intelligent automation. Our goal is simple to create smart, secure, and scalable solutions that make work easier, improve how you connect with customers, and support steady, long-term growth as your business evolves.
                            </p>

                            {/* Bottom Border Animations */}
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <WhyAIAutomation title="Why AI & Automation with Mobikode?" fData={featuresData} />
            <TechServicesSection title="Our Service Offerings" sData={services} />
            <IndustriesWeServe />
            <WhyPartnerWithUs />
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Agentic AI Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[588px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Agentic AI Services for Enterprises
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik mb-8">
                            We help businesses work smarter with AI that can think, act, and adapt. It improves efficiency, supports better decisions, and brings real innovation to everyday operations.

                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>

                </div>

            </section> */}
            <Banner title="AI & Automation" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
        </div>
    )
}

export default NewAI
